import { type NucleicAcidType, OD_FACTORS } from "@/lib/science/nucleic-acid";
import { finite } from "@/lib/science/units";

/**
 * Nucleic acid concentration from A260.
 *   concentration (µg/mL) = A260 × dilution factor × type factor
 * where the type factor is 50 (dsDNA), 33 (ssDNA) or 40 (ssRNA) µg/mL per OD.
 * µg/mL is numerically equal to ng/µL.
 */
export function od260ToConcentration(
  a260: number,
  dilution: number,
  type: NucleicAcidType,
): number | null {
  if (!finite(a260, dilution)) return null;
  return a260 * dilution * OD_FACTORS[type];
}

/** A260/A280 purity ratio (~1.8 for pure DNA, ~2.0 for pure RNA). */
export function purityRatio(a260: number, a280: number): number | null {
  if (!finite(a260, a280) || a280 === 0) return null;
  return a260 / a280;
}
